var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95982 6.46515L1.7506 4.25751C1.63156 4.13855 1.47011 4.07173 1.30176 4.07173C1.13341 4.07173 0.971952 4.13855 0.852911 4.25751C0.733869 4.37647 0.666992 4.53781 0.666992 4.70604C0.666992 4.78934 0.683411 4.87182 0.715311 4.94878C0.747211 5.02574 0.793967 5.09566 0.852911 5.15456L3.51416 7.81391C3.76246 8.06203 4.16355 8.06203 4.41185 7.81391L11.1477 1.08284C11.2668 0.963881 11.3337 0.802542 11.3337 0.634312C11.3337 0.466082 11.2668 0.304742 11.1477 0.185786C11.0287 0.0668292 10.8672 0 10.6989 0C10.5305 0 10.3691 0.0668292 10.25 0.185786L3.95982 6.46515Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowComplete);
export default __webpack_public_path__ + "static/media/arrow-complete.226401add6e17247fd13addffed0f725.svg";
export { ForwardRef as ReactComponent };